import axios from "axios";
import { API_URL, DEHASH_API_URL } from "../utils/constant";
import { DARK_WEB, DARK_WEB_GRAPH} from "./index";
import { toastr } from 'react-redux-toastr';




export const fetchDarkWebResult = (props, dispatch, page, category, startDate, endDate, limit, search = '', keyword = 'all') => {
    if(props){
      let url = `${API_URL}/darkwebForum/${props}?page=${page}&limit=${limit}&category=${category}&from=${startDate}&till=${endDate}&search=${search}`;
      if (keyword && keyword !== 'all') {
        url += `&keyword=${keyword}`;
      }
      axios
        .get(url, {})
        .then((res) => {
          dispatch({
            type: DARK_WEB,
            payload: res.data,
          });
        });
    }
};

export const fetchDarkWebResultUpdate = (props, dispatch, data, clear, p) => {
  if(props){
    axios
      .patch(`${API_URL}/darkwebForum/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchDarkWebResult(props, dispatch, p, 'all', '', '', 10, '', 'all')
          clear()
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchDarkWebDelete = (props,id, dispatch, p) => {
  if (props) {
    axios
      .delete(`${API_URL}/darkwebForum/${props}/${id}/delete`)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchDarkWebResult(props, dispatch, p, 'all', '', '', 10, '', 'all')
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchDarkWebAction = (props, dispatch, page , data, category, keyword = 'all',limit) => {
  if(props){
    let url = `${API_URL}/darkwebForum/${props}/action?page=${page}&category=${category}&limit=${limit}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: DARK_WEB,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchDarkWebGraph = (props, dispatch) => {
  if(props){
    axios
      .get(`${API_URL}/darkwebForum/${props}/graph`)
      .then((res) => {
        dispatch({
          type: DARK_WEB_GRAPH,
          payload: res.data,
        });
      });
  }
};

